import { InjectionToken } from '@angular/core';

export const AnalyticsConstants = {
  INDUSTRY_TYPE_TRANSLATION_PREFIX: 'ANALYTICS.INDUSTRY_TYPE.',
  CUSTOMER_TYPE_TRANSLATION_PREFIX: 'ANALYTICS.CUSTOMER_TYPE.',
  ACCOUNT_TYPES: {
    RESIDENTIAL: 'RESIDENTIAL',
    COMMERCIAL: 'COMMERCIAL',
    INDUSTRIAL: 'INDUSTRIAL',
    CONTRACT: 'CNTRT',
    GUEST: 'GUEST',
  },
  EVENTS: {
    ALERT_BANNER: 'alertBanner',
    ADDRESS_GATE: {
      SUBMIT: 'addressGateSubmit',
    },
    ECOMMERCE: {
      CHECK_ENCLOSURE: 'Checkbox Click: Add Enclosure Flag',
      CHECK_LOCK: 'Checkbox Click: Add Lock Bar',
      UNCHECK_ENCLOSURE: 'Checkbox Unclicked: Remove Enclosure Flag',
      UNCHECK_LOCK: 'Checkbox Unclicked: Remove Lock Bar',
      CART_ADD_ENCLOSURE: 'Add to Cart: Wheels & Enclosure',
      CART_ADD_LOCK: 'Add to Cart: Lock Bar',
      CART_ADD_LOCK_ENCLOSURE: 'Add to Cart: Lock Bar & Wheels Enclosure',
    },
    CART: {
      TRACK_ABANDON_CART_CLEAR: 'abandonCartClear',
      TRACK_PERSISTENT_CART_CLEAR: 'abandonCartClear',
      TRACK_CART_ABANDON: 'abandonedCart',
      TRACK_CART_ABANDON_CHECKOUT: 'abandonedCartCheckout',
      TRACK_CART_PERSISTENT: 'abandonedCart',
      TRACK_CART_PERSISTENT_CHECKOUT: 'abandonedCartCheckout',
      TRACK_CART_VIEW: 'cartView',
      TRACK_CART_ADD: 'addToCart',
      TRACK_CART_REMOVE: 'removeFromCart',
    },
    AUTH: {
      SUCCESS_EVENT: 'loginSuccess',
      LOGGED_IN: 'Logged In',
      LOGGED_OUT: 'Logged Out',
    },
    CONTACT_US: {
      CONTACT_US_SUBMIT: 'contactUsSubmit',
    },
    WAYFINDER: {
      WAYFINDER_START: 'wayfinderStart',
      WAYFINDER_COMPLETE: 'wayfinderComplete',
    },
    HERO_CAROUSEL: {
      HERO_CAROUSEL_START: 'heroCarouselStart',
      HERO_CAROUSEL_PAUSE: 'heroCarouselPause',
    },
    VIDEO: {
      VIDEO_MODAL_START: 'videoModalStart',
      VIDEO_MODAL_PAUSE: 'videoModalPause',
    },
    CARBON_CALCULATOR: {
      CARBON_CALCULATOR_START: 'carbonCalcStart',
      CARBON_CALCULATOR_OUTPUT: 'carbonCalcOutput',
    },
    CIRCULARITY_SURVEY: {
      CIRCULARITY_SURVEY_INIT: 'AssessmentInit',
      CIRCULARITY_SURVEY_SUBMIT: 'AssessmentSubmit',
    },
    PROMOTION: {
      PROMO_SUCCESS: 'promoSuccess',
      PROMO_ERROR: 'promoError',
    },
    SERVICE_PORTAL: {
      VIEW: 'servicePortalView',
      ACCESSED: 'serviceAccessed',
      SIGN_UP_SUCCESS: 'serviceSignUpSuccess',
      SIGN_UP_FAILURE: 'serviceSignUpFailed',
      SELECTION_PREFIXES: {
        APP_SWITCHER: 'servicePortalView | ',
        DROPDOWN_MENU: 'servicePortalMenuView | ',
      },
      SIGNUP_CLICK: 'Custominteraction',
    },
    LEAD_FORM: {
      LEAD_FORM_COMPLETE: 'formComplete',
      LEAD_FORM_INIT: 'formInit',
    },
  },
  ACTIONS: {
    ABANDON_CART_CLEAR: 'abandonCartClear',
    ADD_TO_CART: 'cartadd',
    ADDRESS_AUTO_LOOKUP: 'ADDRESS_AUTO_LOOKUP',
    CART_ABANDON: 'abandonedCart',
    CART_ABANDON_CHECKOUT: 'abandonedCartCheckout',
    CART_VIEW: 'cartView',
    CART_PERSISTENT_CHECKOUT: 'abandonedCartCheckout',
    CATEGORIES: 'categoriesview',
    CATEGORY_CLICK: 'categoryclick',
    NEVER_MIND: 'startovernevermind',
    PERSISTENT_CART_CLEAR: 'abandonCartClear',
    PRODUCT_DETAIL_VIEW: 'productview',
    REMOVE_FROM_CART: 'cartremove',
    START_OVER: 'startover',
    START_OVER_ICON: 'startovericon',
    SUGGESTED_ADDRESS_TRIGGERED: 'SUGGESTED_ADDRESS_TRIGGERED',
    SUGGESTED_ADDRESSES_FOUND: 'SUGGESTED_ADDRESSES_FOUND',
    SUGGESTED_ADDRESS_1_FOUND: 'SUGGESTED_ADDRESS_1_FOUND',
    SUGGESTED_ADDRESS_NOT_FOUND: 'SUGGESTED_ADDRESS_NOT_FOUND',
    SIGNUP: 'signup',
  },
  OTHER: {
    ECOMMERCE: {
      FLAGS: {
        CASTERS_OFF: 'WF-N',
        CASTERS_ON: 'WF-W',
        ENCLOSURE_OFF: 'EF-N',
        ENCLOSURE_ON: 'EF-E',
        LOCK_OFF: 'LF-N',
        LOCK_ON: 'LF-L',
      },
      CUSTOMER_STATUS: {
        EXISTING: 'Existing',
        NEW: 'New',
      },
    },
  },
  PORTAL_NAME: {
    RW: 'R&W',
  },
  SIGNUP_FLOW: {
    STANDARD: 'Standard',
    EXISTING: 'Existing',
    GUEST_CHECKOUT: 'Guest-Checkout',
  },
  TERMS: {
    ONE_TIME: 'one-time',
  },
};

export type AnalyticsConstantsType = typeof AnalyticsConstants;

export const analyticsConstantsToken =
  new InjectionToken<AnalyticsConstantsType>('analyticsConstantsToken');
